import React, { useMemo }  from 'react';
import { USER_ROLES, USER_STATES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useUserProfileStore } from 'store/user/useUserProfileStore';

const Information = () => {
	// Use user's profile store
	const user = useUserProfileStore(state => state.user);

	// Find additional info
	const role = useMemo(() => USER_ROLES.find(role => role.value === user.role), [user.role]);
	const status = useMemo(() => USER_STATES.find(status => status.value === user.status), [user.status]);

	return (
		<Container className="p-4 space-y-2">
			<div className="flex justify-between space-x-2">
				<Avatar
					alt={user.fullName}
					src={user.avatar}
					online={user.online}
					className="w-12 h-12"
				/>

				<Button
					small
					square
					icon="edit"
					to={`/users/edit/${user.id}`}
					className="font-normal"
				/>
			</div>
				
			<Title
				title={user.fullName}
				subtitle={user.email}
				className="text-xl"
			/>

			<div className="flex space-x-2">
				<Pill
					name={role?.name}
				/>

				<Pill
					name={status?.name}
					theme={status?.theme}
				/>
			</div>
		</Container>
	);
};

export default Information;